
export class State {
   stateCode: string;
   description: string;
   constructor() {}
   static parse (data: any): State {
     return Object.assign(new State(), {
       stateCode: data.stateCode,
       description: data.description
     });
   }
}
